var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlassMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500.284 443.717L380.623 324.055C407.845 283.64 421.271 233.159 414.082 179.355C401.848 87.802 326.803 13.327 235.167 1.724C99.014 -15.515 -15.509 99.004 1.722 235.155C13.32 326.794 87.793 401.844 179.349 414.081C233.154 421.272 283.638 407.846 324.052 380.625L443.717 500.285C459.337 515.905 484.662 515.905 500.283 500.286L500.283 500.286C515.905 484.665 515.905 459.338 500.284 443.717ZM288.002 232H127.998C114.73 232 104 221.258 104 208S114.738 184 127.998 184H288.002C301.261 184 312 194.742 312 208S301.261 232 288.002 232Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassMinus);
export default __webpack_public_path__ + "static/media/magnifying-glass-minus.7d08b1b812df07f2a28ae40dfe28b808.svg";
export { ForwardRef as ReactComponent };